import {
  Alert,
  Box,
  Grid,
  LinearProgress,
  Paper,
  Typography,
  Chip,
  Divider,
} from "@mui/material";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { useParams } from "react-router-dom";
import useFetchData from "../../../utility/useFecthData";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const DetailDeclarationComponent = () => {
  let { id } = useParams();
  const { data, isLoading, error } = useFetchData(
    "online_declaration_detaches/" + id
  );
  const [declaration, setDeclaration] = useState(null);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    if (data) {
      setDeclaration(data?.data.declaration);
      setUserName(data?.data?.user);
    }
    return () => {
      setDeclaration(null);
    };
  }, [data]);

  return (
    <Box
      sx={{
        margin: { xs: 2, md: 4, lg: 8 },
      }}
    >
      {isLoading && (
        <LinearProgress
          sx={{
            backgroundColor: "#e0e0e0",
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#00a652",
            },
          }}
        />
      )}

      {error && <Alert severity="error">{JSON.stringify(error)}</Alert>}

      {declaration && (
        <Paper elevation={2} sx={{ p: 4 }}>
          <Grid container spacing={3}>
            {/* Header Section */}
            <Grid item xs={12}>
              <Typography
                variant="h5"
                sx={{
                  color: "#00a652",
                  fontWeight: 500,
                  mb: 3,
                  textAlign: "left",
                }}
              >
                {declaration.titre}
              </Typography>
              <Divider sx={{ mb: 3 }} />
            </Grid>

            {/* Main Info Section */}
            <Grid item xs={12} md={8}>
              <Box sx={{ mb: 3 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ mb: 2, textAlign: "left" }}
                >
                  Code de l'institution:{" "}
                  <Chip
                    label={declaration.code_instution}
                    sx={{
                      backgroundColor: "#00a652",
                      color: "white",
                    }}
                  />
                </Typography>
                <Typography variant="subtitle1" sx={{ textAlign: "left" }}>
                  Période:{" "}
                  <strong>
                    {declaration.mois} / {declaration.annee}
                  </strong>
                </Typography>
              </Box>

              {/* Description Box */}
              <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
                <ReactQuill
                  value={declaration.description}
                  readOnly={true}
                  modules={{ toolbar: false }}
                  theme="snow"
                />
              </Paper>
            </Grid>

            {/* Side Info Section */}
            <Grid item xs={12} md={4}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  backgroundColor: "rgba(0, 166, 82, 0.04)",
                }}
              >
                <Typography variant="subtitle2" sx={{ mb: 2 }}>
                  Date de déclaration:{" "}
                  <strong>{declaration?.date_declaration}</strong>
                </Typography>

                <Typography variant="subtitle2" sx={{ mb: 2 }}>
                  Transmis le:{" "}
                  <strong>{declaration?.created_at?.split("T")[0]}</strong>
                </Typography>

                {userName && (
                  <Typography variant="subtitle2" sx={{ mb: 3 }}>
                    Envoyé par:{" "}
                    <Chip
                      label={userName.name}
                      size="small"
                      sx={{ backgroundColor: "#00a652", color: "white" }}
                    />
                  </Typography>
                )}

                {/* Attached Documents Section */}
                <Typography
                  variant="h6"
                  sx={{ color: "#00a652", mt: 3, mb: 2 }}
                >
                  Documents attachés
                </Typography>

                {declaration.file_uploaded_one && (
                  <Box sx={{ mb: 1 }}>
                    <a
                      href={declaration.file_uploaded_one}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#00a652",
                        textDecoration: "none",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      <AttachFileIcon sx={{ mr: 1 }} />
                      {declaration.file_name_one}
                    </a>
                  </Box>
                )}

                {declaration.file_uploaded_two && (
                  <Box sx={{ mb: 1 }}>
                    <a
                      href={declaration.file_uploaded_two}
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#00a652",
                        textDecoration: "none",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      <AttachFileIcon sx={{ mr: 1 }} />
                      {declaration.file_name_two}
                    </a>
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>
        </Paper>
      )}
    </Box>
  );
};

export default DetailDeclarationComponent;
